import React, { Fragment, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { H6, P, Btn } from "../../../../AbstractElements";
import { Clipboardon, Copy, CopyParagraph } from "../../../../Constant";
import HeaderCard from "../../../Common/HeaderCard";

const ClipboardPara = () => {
  const vall = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";
  const [clipBoardValues, setClipBoardValues] = useState(vall);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(clipBoardValues);
    setClipBoardValues(clipBoardValues);
  };
  return (
    <Fragment>
      <Col sm="12" md="6">
        <Card>
          <HeaderCard title={Clipboardon} />
          <CardBody>
            <div className="clipboaard-container">
              <P className="card-description">{CopyParagraph}</P>
              <H6 className="border rounded card-body f-w-300">{vall}</H6>
              <div className="mt-3 text-end">
                <Btn color="primary btn-clipboard" onClick={handleCopy}>
                  <i className="fa fa-copy"></i> {Copy}
                </Btn>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default ClipboardPara;
